import React from "react";
import { Container } from "./styled/badge";

function Badge(props) {
  return <Container {...props} />;
}

export default Badge;
